import React from 'react'

import ZoomIn from './icons/icon-zoom-in.png'
import ZoomOut from './icons/icon-zoom-out.png'
import chartHistogram from './icons/icon-chart-histogram.png'
import Layers from './icons/icon-layers.png'
import LocalPin from './icons/icon-local-pin.png'
import IconAdd from './icons/icon-add.png'
import IconFlipHorizontally from './icons/icon-flip-horizontally.png'

export enum MapViewCondition {
  zoomIn = 'zoomIn',
  zoomOut = 'zoomOut',
  chartHistogram = 'chartHistogram',
  layers = 'layers',
  localPin = 'localPin',
  add = 'add',
  flipHorizontally = 'flipHorizontally',
}

const iconMap = {
  [MapViewCondition.zoomIn]: ZoomIn,
  [MapViewCondition.zoomOut]: ZoomOut,
  [MapViewCondition.chartHistogram]: chartHistogram,
  [MapViewCondition.layers]: Layers,
  [MapViewCondition.localPin]: LocalPin,
  [MapViewCondition.add]: IconAdd,
  [MapViewCondition.flipHorizontally]: IconFlipHorizontally,
}

interface MapViewIconProps {
  condition?: MapViewCondition
  width?: number
  height?: number
}

export const MapViewIcon: React.FC<MapViewIconProps> = ({
  condition,
  width = 17,
  height = 17,
}) => (
  <img
    src={condition ? iconMap[condition] : undefined}
    alt={'alt'}
    width={width}
    height={height}
  />
)
